var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39205 2.2253C2.69245 1.9249 3.1795 1.9249 3.47991 2.2253L12.7107 11.4561C13.0111 11.7565 13.0111 12.2435 12.7107 12.5439L3.47991 21.7747C3.1795 22.0751 2.69245 22.0751 2.39205 21.7747C2.09165 21.4743 2.09165 20.9872 2.39205 20.6868L11.0789 12L2.39205 3.31316C2.09165 3.01276 2.09165 2.52571 2.39205 2.2253Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5459 2.2253C8.8463 1.9249 9.33335 1.9249 9.63375 2.2253L18.8645 11.4561C19.1649 11.7565 19.1649 12.2435 18.8645 12.5439L9.63375 21.7747C9.33335 22.0751 8.8463 22.0751 8.5459 21.7747C8.24549 21.4743 8.24549 20.9872 8.5459 20.6868L17.2327 12L8.5459 3.31316C8.24549 3.01276 8.24549 2.52571 8.5459 2.2253Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPage);
export default __webpack_public_path__ + "static/media/last_page.706ddc5a0c49f906e706050ad4ebb279.svg";
export { ForwardRef as ReactComponent };